import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchPackages = () => axios.get(`${API}/packages`).then((r) => r.data);

export const fetchPackage = (slug) => axios.get(`${API}/packages/${slug}`).then((r) => r.data);

export const submitLead = (payload) => axios.post(`${API}/leads`, payload).then((r) => r.data);
